module.exports = __webpack_public_path__ + "img/card_1.85ccaa7f.jpg";